exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-54f5fff8] .el-date-editor{width:100%}[data-v-54f5fff8] .el-textarea__inner{resize:none}[data-v-54f5fff8] .el-input-number--medium{width:100%}[data-v-54f5fff8] .el-select--medium{width:100%}[data-v-54f5fff8] .el-form-item:last-of-type{margin-bottom:0}.dialog-footer[data-v-54f5fff8]{padding-top:20px}\n", ""]);

// exports
